/* ProminentSectionInfo.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "._18s8ysrw{margin:var(--_14zfq5t)}";
const _13 = "._k48p1fw0{font-weight:700}";
const _12 = "._syazzjem{color:var(--ds-text-discovery,#5e4db2)}";
const _11 = "@media (min-width:30rem) and (max-width:47.99rem){._1cj6u2gc{gap:var(--ds-space-100,8px)}._uhd028ou{max-width:40.625rem}}";
const _10 = "@media (min-width:0rem) and (max-width:29.99rem){._e4o012x7{gap:var(--ds-space-075,6px)}}";
const _9 = "._4cvr1y6m{align-items:flex-start}";
const _8 = "._2lx21bp4{flex-direction:column}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._2rkopxbi{border-radius:var(--ds-space-200,1pc)}";
const _5 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _4 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _3 = "._18s8zu5n{margin:var(--ds-space-200,1pc) 0}";
const _2 = "._syaz10m5{color:var(--ds-text-accent-purple,#5e4db2)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, H2, H3, LinkWithIcon } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
export const Card = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H2,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz10m5", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const Description = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8zu5n _syaz1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const HeadingStyle = null;
const DescriptionStyle = null;
const CardStyle = null;
export const ProminentSectionInfo = _ref4 => {
  let {
    title,
    description,
    navigationUrl
  } = _ref4;
  const history = useHistory();
  const {
    tractExploreMoreAppClick
  } = useHomepageAnalytics();
  const navigationLinkClickHandler = event => {
    event.preventDefault();
    if (navigationUrl) tractExploreMoreAppClick(title, navigationUrl);
    history === null || history === void 0 ? void 0 : history.push(navigationUrl);
  };
  const ariaLabel = title.toLowerCase().includes('apps') ? "Explore more ".concat(title) : "Explore more ".concat(title, " apps");
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_5, _6, _7, _8, _9, _10, _11]
      }), /*#__PURE__*/_jsxs(Card, {
        as: "li",
        className: ax(["_zulppxbi _2rkopxbi _1e0c1txw _2lx21bp4 _4cvr1y6m _e4o012x7 _1cj6u2gc _uhd028ou"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_12, _13]
          }), /*#__PURE__*/_jsx(H3, {
            as: "h2",
            className: ax(["_syazzjem _k48p1fw0"]),
            children: title
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_14, _7, _4]
          }), /*#__PURE__*/_jsx(BodyLarge, {
            className: ax(["_18s8ysrw _1e0c1txw _syaz1gjq"]),
            style: {
              "--_14zfq5t": ix("var(--ds-space-200, 16px)".concat(" 0rem"))
            },
            children: description
          })]
        }), navigationUrl && /*#__PURE__*/_jsx(LinkWithIcon, {
          size: "medium",
          type: "internal",
          onClick: event => navigationLinkClickHandler(event),
          href: navigationUrl,
          "aria-label": ariaLabel,
          children: "Explore more apps"
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Card, {
    as: "li",
    children: [/*#__PURE__*/_jsx(Heading, {
      children: title
    }), /*#__PURE__*/_jsx(Description, {
      children: description
    }), navigationUrl && /*#__PURE__*/_jsx(LinkWithIcon, {
      size: "medium",
      type: "internal",
      onClick: event => navigationLinkClickHandler(event),
      href: navigationUrl,
      "aria-label": ariaLabel,
      children: "Explore more apps"
    })]
  });
};